import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { EmailData } from "./email.data";
import { useAttributeValueComponents, useRenderers, IconAndTitle } from "@me8eon/renderers";
import { Icon } from "@me8eon/icons";
import { SimpleWidget } from "@me8eon/simple_widget";
import { useTranslation } from "@me8eon/translation";
import { PhotoDisplay } from "@me8eon/people_data_plugin";
import { getFormattedDateTime } from "@me8eon/time";
import React, { useMemo } from "react";
// @ts-ignore
import icon from "./mail.svg"

export const EmailDisplay: DisplayData<EmailData> =
    ({ rootId, id, data }: DisplayDataProps<EmailData>) => {
        const { H1WithUrl, H3, Url, Text: JustText } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const resource = data.resource;
        const t = useTranslation();

        if (!resource) {
            console.log('EmailDisplay: no resource', data);
            return <div>No email data available</div>;
        }
        const { subject, sender, bodyPreview, receivedDateTime, webLink } = resource;

        const senderName = sender?.emailAddress?.name || "Unknown Sender";
        const senderEmail = sender?.emailAddress?.address || "";

        const cleanedName = senderName.replace(/[\(<].*?[\)>]/g, '').trim();
        const nameParts = cleanedName.split(/[\s,;&]+/);
        nameParts.map(n => n.charAt(0)).join("").toUpperCase();

        const emailInitials = nameParts.map(n => n.charAt(0)).join("").toUpperCase();

        const dataObj = useMemo(() =>
            ({ url: webLink, title: subject }), [subject, webLink]);

        return (
            <DataLayout rootId={newRootId} className="email-data" layout={[1, 1, 1]}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <PhotoDisplay photoName={emailInitials} height="32px" width="32px" minWidth="32px" fontSize="18px" />
                        <H3 rootId={newRootId} attribute={translateLabelForData("sender")} value={senderName} />
                    </div>
                    <div className="view_email_link" style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", marginTop: "8px" }}>
                        <JustText rootId={newRootId} attribute={translateLabelForData("received")} value={getFormattedDateTime(new Date(receivedDateTime), "D d MMM yyyy | h.i A", true)} />
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", paddingTop: "8px", borderTop: "1px solid #cccbca" }}>
                    <div style={{ overflow: "hidden", whiteSpace: "nowrap" }}>
                        <H1WithUrl rootId={newRootId} attribute={translateLabelForData("subject")} value={dataObj} />
                    </div>
                    <Url
                        icon={() => (<Icon name="mail" />)}
                        rootId={id}
                        width="120px"
                        customStyles={{ justifyContent: "flex-end" }}
                        attribute={translateLabelForData("url")}
                        label={t(translateLabelForData("viewEmail"))}
                        value={webLink}
                    />
                </div>

                <div style={{ gap: "10px" }}>
                    <JustText rootId={newRootId} attribute={translateLabelForData("subject")} value={subject} />
                    <Text rootId={newRootId} attribute={translateLabelForData("preview")} value={bodyPreview} />
                </div>
            </DataLayout >
        );
    };

export const OneLineEmailDisplay: DisplayData<EmailData> =
    ({ data, listItemClicked }: DisplayDataProps<EmailData>) => {
        const { SearchListItem } = useRenderers();

        const { subject, sender, bodyPreview, receivedDateTime, webLink } = data.resource;
        const senderName = sender?.emailAddress?.name || "Unknown Sender";
        const issueSummaryAndUrl: IconAndTitle = useMemo(() =>
        ({
            title: `${senderName}: ${subject}`,
            icon: icon,
            onClick: () => { listItemClicked && listItemClicked(`${senderName}: ${subject}`); },
        }), [data.resource]);
        return (
            <SearchListItem key={subject} rootId={subject} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
        );
    };

export const SimpleEmailWidget: DisplayDataWidget<EmailData> =
    SimpleWidget(
        [],
        [],
        []);

